import axios from "axios"

const actionGetAllBirths = async ({commit}, payload) => {
  const results = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/${payload}/all_births`);
  commit("SET_ALL_BIRTHS", results.data);
}

// Bloqueio do RIL (75/150 dias, pesagem Aprovado) checado no parto clicado.
const actionCheckIfCanExportRill = async (_, payload) => {
  const permissions = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animal_births/${payload}/check_ril`);
  return permissions.data;
}

const actionCleanResults = ({commit}) => {
  commit("CLEAN_RESULTS");
}

export default {
  actionGetAllBirths,
  actionCheckIfCanExportRill,
  actionCleanResults
}